module.exports = __webpack_public_path__ + "img/comparisonHandler.efbef740.svg";